<div *ngIf="showGrade" [ngStyle]="{ 'height.px': radius * 2 + 2, 'width.px': radius * 2 + 2 }" class="grade-container">
  <svg [ngClass]="[size, gradeLetter]">
    <circle cx="50%" cy="50%" [attr.r]="radius" />
    <text text-anchor="middle" y="50%" x="50%" dy="0.35em" fill="white" data-testid="grade-letter">
      {{ gradeLetter }}
    </text>
  </svg>
</div>
